import React, { useState } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import { connect } from 'react-redux';
import BulkUploadPrompt from './BulkUploadPrompt';
import ExportHistoryFiles from './ExportHistoryFiles';
import { openHelpUrl } from '../../../utills';
import styles from './Styles/upload-prompt.scss';

const BulkUploadNewSlider = props => {
  const [currentStep, setcurrentStep] = useState(() => 1);
  const leftIcons = [
    {
      className: 'icon-HDRback',
      onClick: () => {
        props.onHidden();
        window.history.back();
      }
    }
  ];
  const rightIcons = [
    {
      className: 'icon-HDRhelp',
      onClick: () => {
          openHelpUrl('Products-View-Bulk-Update-Products', props.isMobile ? true : false);
      }
    },
    {
      className: 'icon-glHistory icon-piHistory' + ' ' + styles['bigIcon'],
      onClick: () => {
        setcurrentStep(() => 2)
      }
    }
  ]

  return (
    <SliderWrapper
      header={{
        heading: 'Bulk Update Products',
        leftIcons,
        rightIcons,
      }}
    >
      {/* <BulkUploadPrompt /> */}
      {currentStep === 1 ?
        <BulkUploadPrompt session={props.session} setCurrentStep={() => setcurrentStep(() => 2)}/> :
        <ExportHistoryFiles session={props.session} onHidden={props.onHidden} setCurrentStep={() => setcurrentStep(() => 1)} />
      }
    </SliderWrapper>
  )
};

const mapStateToProps = state => {
  return {
    supplierId: state.session.supplierId,
    isMobile: state.library.deviceData.isMobile,
    session: state.session
  }
}

export default connect(mapStateToProps)(BulkUploadNewSlider);